// Header + footer link data. All links absolute to gdprlocal.com to match the
// live site exactly. This page must feel like a native gdprlocal.com page.
const BASE = "https://gdprlocal.com";
const PORTAL = "https://portal.gdprlocal.com";

export const SITE = {
  logo: "https://gdprlocal.com/wp-content/uploads/2024/10/logo_header.png",
  icon: "https://gdprlocal.com/wp-content/uploads/2024/10/fav1.png",
  home: BASE + "/",
  signIn: PORTAL + "/Account/Login",
  contactSales: BASE + "/contact/",
  signUp: PORTAL + "/Account/Register",
  contact: BASE + "/contact/",
};

export const NAV = [
  {
    label: "Services",
    items: [
      { label: "EU Representative", href: BASE + "/gdpr-article-27-eu-representative/" },
      { label: "UK Representative", href: BASE + "/gdpr-article-27-uk-representative/" },
      { label: "Swiss Representative", href: BASE + "/fadp-article-14-swiss-representative/" },
      { label: "EU AI Act Article 22 Representative", href: BASE + "/ai-representative/" },
      { label: "DPO Service", href: BASE + "/gdpr-data-protection-officer/" },
      { label: "Singapore DPO", href: BASE + "/singapore-dpo/" },
      { label: "Consultancy", href: BASE + "/gdpr-consultant/" },
      { label: "AI Governance", href: BASE + "/ai-governance/" },
      { label: "AI and Data Protection Training", href: BASE + "/ai-and-data-protection-compliance-training/" },
      { label: "Project Delivery", href: BASE + "/compliance-projects/" },
    ],
  },
  {
    label: "Solutions",
    items: [
      { label: "Start-ups and fast movers", href: BASE + "/solutions/start-ups-and-fast-movers/" },
      { label: "SME and hyper growth", href: BASE + "/solutions/sme-and-hyper-growth/" },
      { label: "Corporates and enterprise", href: BASE + "/solutions/corporates-and-enterprise/" },
      { label: "By approach", href: BASE + "/solutions/by-approach/" },
    ],
  },
  {
    label: "Frameworks",
    items: [
      { label: "Data Protection", href: BASE + "/frameworks/data-protection/" },
      { label: "Info Sec SOC2 / ISO27001", href: BASE + "/frameworks/info-sec-soc2-iso27001/" },
      { label: "AI Act", href: BASE + "/frameworks/info-sec-soc2-iso27001/#aiact" },
    ],
  },
  { label: "Pricing", href: BASE + "/pricing/" },
  {
    label: "About Us",
    items: [
      { label: "About us", href: BASE + "/about-us/" },
      { label: "Contact", href: BASE + "/contact/" },
    ],
  },
  {
    label: "Resources",
    items: [
      { label: "Blog", href: BASE + "/blog/" },
      { label: "Data Protection Glossary", href: BASE + "/data-protection-glossary/" },
      { label: "GDPR Enforcement Tracker", href: BASE + "/gdpr-enforcement-tracker/" },
      { label: "FAQ", href: BASE + "/faq/" },
      { label: "Partners", href: BASE + "/partners/" },
    ],
  },
];

export const FOOTER = {
  cta: {
    heading: "AI Regulation is here, GDPRLocal can help",
    sub: "Need help with an AI risk assessment? Looking for advice on governance? Need a complete set of compliance documentation? Our experienced data protection and AI consultants can help.",
    ticks: ["No credit card required", "Easy setup"],
    button: { label: "Sign up free", href: PORTAL + "/Account/Register" },
  },
  columns: [
    {
      title: "Services",
      links: [
        { label: "EU Representative", href: BASE + "/gdpr-article-27-eu-representative/" },
        { label: "UK Representative", href: BASE + "/gdpr-article-27-uk-representative/" },
        { label: "Swiss Representative", href: BASE + "/fadp-article-14-swiss-representative/" },
        { label: "EU AI Act Article 22 Representative", href: BASE + "/ai-representative/" },
        { label: "DPO Service", href: BASE + "/gdpr-data-protection-officer/" },
        { label: "Singapore DPO", href: BASE + "/singapore-dpo/" },
        { label: "Consultancy", href: BASE + "/gdpr-consultant/" },
        { label: "AI Governance", href: BASE + "/ai-governance/" },
        { label: "AI and Data Protection Training", href: BASE + "/ai-and-data-protection-compliance-training/" },
        { label: "Project Delivery", href: BASE + "/compliance-projects/" },
      ],
    },
    {
      title: "Solutions",
      links: [
        { label: "Start up and Fast Movers", href: BASE + "/solutions/start-ups-and-fast-movers/" },
        { label: "SME and Hyper Growth", href: BASE + "/solutions/sme-and-hyper-growth/" },
        { label: "Corporates and Enterprise", href: BASE + "/solutions/corporates-and-enterprise/" },
        { label: "By approach", href: BASE + "/solutions/by-approach/" },
      ],
    },
    {
      title: "Frameworks",
      links: [
        { label: "Data Protection", href: BASE + "/frameworks/data-protection/" },
        { label: "Info Sec SOC2 / ISO27001", href: BASE + "/frameworks/info-sec-soc2-iso27001/" },
        { label: "AI Act", href: BASE + "/frameworks/info-sec-soc2-iso27001/#aiact" },
      ],
    },
    {
      title: "About us",
      links: [
        { label: "About us", href: BASE + "/about-us/" },
        { label: "Contact", href: BASE + "/contact/" },
        { label: "Partners", href: BASE + "/partners/" },
        { label: "Affiliate", href: BASE + "/affiliate/" },
      ],
    },
  ],
  company: {
    line1: "GDPRLocal Ltd, UK Reg: 12969035",
    line2: "1st Floor Front Suite, 27-29 North Street, Brighton, England, BN1 1EB",
  },
  bottom: {
    copyright: "GDPRLocal 2026 \u00a9 All Rights Reserved",
    legal: [
      { label: "Cookie Policy", href: BASE + "/cookie-policy/" },
      { label: "Privacy Policy", href: BASE + "/privacy-statement/" },
      { label: "DPA/SCC/ADDENDUM", href: BASE + "/dpa-scc-addendum/" },
      { label: "NDA", href: BASE + "/nda/" },
      { label: "Terms and Conditions", href: BASE + "/terms-of-use/" },
    ],
  },
};
